<template>
  <div id="nav" class="border-bottom">
    <b-row class="mb-3">
      <b-col class="nav-links alt-text">
        <router-link to="/">Products</router-link>
        <router-link to="/invoices">Invoices</router-link>
        <a href="">Tools</a>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <div
          @click="showNotifications = !showNotifications"
          class="notifications d-flex mr-3 link-style"
        >
          <i class="fas fa-bell"></i>
          <div
            class="notification-count rounded-circle bg-info text-white text-center nm-sm"
          >
            2
          </div>
        </div>
        <div class="d-flex">
          <i
            class="fas fa-user-circle fa-2x text-dark nm-sm rounded-circle"
          ></i>
          <div class="d-flex flex-column current-account ml-2">
            <span>DMI — A118290</span>
            <span>nick.randall@retailerwebservices.com</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <transition>
      <b-row class="notification-container" v-if="showNotifications">
        <b-col>
          <P class="font-weight-bold text-info mt-3 alt-text">
            NOTIFICATIONS
            <span
              class="link-style text-small hide-text"
              v-if="showNotifications"
              @click="showNotifications = false"
              >( hide )</span
            >
          </P>
          <div
            class="notification text-small d-flex justify-content-between align-items-center p-2 my-2 border"
            v-for="(notification, i) in notifications"
            :key="`notification-${i}`"
          >
            <span>{{ notification.text }}</span>
            <a
              target="_blank"
              class="text-info"
              v-if="notification.action"
              :href="notification.action"
              title="More Details"
              >More Details</a
            >
          </div>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {},
  data() {
    return {
      showNotifications: false,
      notifications: [
        {
          text:
            'CONSUMER_FINANCE: consumer_finance.dat: File Too Old, Expecting Less Than 960 hours old, currently 14192 hours old',
          action: '/admin/monitor_dashboard.html'
        },
        {
          text:
            'CONSUMER_FINANCE: consumer_finance.dat: File Too Old, Expecting Less Than 960 hours old, currently 14192 hours old',
          action: '/admin/monitor_dashboard.html'
        }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#nav {
  padding: 20px 20px 0 20px;
  text-align: left;

  .nav-links a {
    padding: 0 7px 20px;
    margin: 0 23px;
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #235e88;
      border-bottom: 4px solid #3e96db;
      border-radius: 2px 2px 2px 2px;
    }
  }

  .notifications {
    width: 40px;
    position: relative;
    .fa-bell {
      transform: rotate(30deg);
      font-size: 1.25rem;
    }
    .notification-count {
      width: 20px;
      height: 20px;
      font-size: 0.9rem;
      position: absolute;
      top: -10px;
      right: 0;
    }
  }
  .current-account {
    font-size: 0.7rem;
  }
  .notification,
  .hide-text {
    font-size: 0.8rem;
  }
}
</style>
